import { useState } from "react";
import { CompanyDetails } from "./components";
import { showErrorToast, showSuccessToast } from "../../utils";
import { hideAppSpinner, showAppSpinner } from "../../context/Store/slices/appSpinnerSlice";
import { useDispatch } from "react-redux";
import { useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { PlanDetails } from "./components/PlanDetails";
import { useCreatePlan, useSendPlan } from "../../hooks/query";

function ISSBPlan() {
  const toast = useToast();
  const dispatch = useDispatch();
  const { t } = useTranslation("translation", { keyPrefix: "issbPlan" });

  const [activePageIndex, setActivePageIndex] = useState(0);
  const [planData, setPlanData] = useState();

  const handleErrors = (error) => {
    const errorMessage = error.response?.data?.parameters?.message ?? error.message;
    dispatch(hideAppSpinner());
    showErrorToast(toast, errorMessage);
  };

  const { mutate: createPlan } = useCreatePlan({
    onSuccess: (data) => {
      setPlanData(data);
      setActivePageIndex(1);
    },
    onError: err => handleErrors(err),
    onSettled: () => {
      dispatch(hideAppSpinner());
    }
  });

  const { mutate: sendPlan } = useSendPlan({
    onSuccess: () => {
      showSuccessToast(toast, t("planDetails.messages.planSentSuccessfully"));
    },
    onError: err => handleErrors(err),
    onSettled: () => {
      dispatch(hideAppSpinner());
    }
  });

  const handleCreatePlan = (data) => {
    dispatch(showAppSpinner);
    createPlan(data);
  };

  const handleSendPlan = () => {
    dispatch(showAppSpinner);
    sendPlan({ surveyId: planData.id });
  };

  return (
    <>
      {activePageIndex === 0 ?
        <CompanyDetails handleCreatePlan={handleCreatePlan} /> :
        <PlanDetails planData={planData} handleSendPlan={handleSendPlan} />
      }
    </>
  );
}

export default ISSBPlan;